// import { analysisService } from "../../../shared/services/api/analysis/analysisService";
// import { RowData } from "../types";

// interface SaveResult {
// 	success: boolean;
// 	message: string;
// 	rowIndex: number;
// 	cpf: string;
// }

// export const handleSave = async (
// 	payloads: any[],
// 	dataOriginal: RowData[],
// 	analysisId: string,
// 	debug: boolean,
// 	originalIndexes: number[]
// ): Promise<SaveResult[]> => {
// 	const results: SaveResult[] = [];

// 	for (let i = 0; i < payloads.length; i++) {
// 		const payload = payloads[i];
// 		const rowIndex = originalIndexes[i];

// 		const row = dataOriginal.find((r) => r.__index === rowIndex); // aqui é a chave
// 		const cpf = row?.cpf ?? "";

// 		try {
// 			const response = await analysisService.create(payload, analysisId);

// 			results.push({
// 				success: !(response instanceof Error),
// 				message:
// 					response instanceof Error ? `Erro na linha ${rowIndex + 1}: ${response.message}` : `Registro da linha ${rowIndex + 1} salvo com sucesso.`,
// 				rowIndex,
// 				cpf,
// 			});

// 			if (debug) {
// 				console.log(`Linha ${rowIndex + 1} - CPF: ${cpf}`, response);
// 			}
// 		} catch (err) {
// 			console.error("Erro inesperado:", err);
// 			results.push({
// 				success: false,
// 				message: `Erro inesperado na linha ${rowIndex + 1}.`,
// 				rowIndex,
// 				cpf,
// 			});
// 		}
// 	}

// 	return results;
// };


import { analysisService } from "../../../shared/services/api/analysis/analysisService";
import { RowData } from "../types";

interface SaveResult {
	success: boolean;
	message: string;
	rowIndex: number | null;
	cpf: string;
}

/**
 * Realiza o envio dos payloads e retorna os resultados por índice.
 *
 * @param payloads Lista de objetos a serem salvos.
 * @param dataOriginal Dados originais para mapear `cpf` ou status.
 * @param analysisId ID da análise.
 * @param debug Exibir console para depuração.
 * @param indexes Índices de referência correspondentes às linhas no `dataOriginal`.
 */
export const handleSave = async (
	payloads: any[],
	dataOriginal: RowData[],
	analysisId: string,
	debug = false,
	indexes?: (number | null)[]
): Promise<SaveResult[]> => {
	const results: SaveResult[] = [];

	for (let i = 0; i < payloads.length; i++) {
		const payload = payloads[i];
		const rowIndex = indexes?.[i] ?? i;
		const row = dataOriginal[rowIndex];
		const cpf = row?.cpf ?? "";

		try {
			const response = await analysisService.create(payload, analysisId);

			if (response instanceof Error) {
				results.push({
					success: false,
					message: `Erro na linha ${rowIndex + 1}: ${response.message}`,
					rowIndex,
					cpf,
				});
			} else {
				if (debug) console.log("✔️ Registro salvo:", rowIndex, payload);
				results.push({
					success: true,
					message: `Registro da linha ${rowIndex + 1} salvo com sucesso.`,
					rowIndex,
					cpf,
				});
			}
		} catch (err: any) {
			results.push({
				success: false,
				message: `Erro inesperado na linha ${rowIndex + 1}: ${err?.message || "Erro desconhecido"}`,
				rowIndex,
				cpf,
			});
		}
	}

	return results;
};
